/**
 * When a paused composer looks again (Codex review of FE #2325). At an enforced limit the composer
 * locks (a turn refused with `cinch_usage_limit`, or the meter's verdict `blocked`; the same two cases
 * as usageBanner's "Paused until …"). Without a timer it stayed locked after the window reset, until a
 * reload. The provider waits until just after `resets_when`, then clears the refusal and re-reads the meter.
 */

// setTimeout can't wait longer than ~24.8 days (a month window can), and an hourly look also picks up
// a raised cap. Past the reset (the server still says blocked), it looks again a minute later.
export const MAX_RECHECK_MS = 60 * 60 * 1000;
export const AFTER_RESET_MS = 1000;
export const RETRY_MS = 60 * 1000;

/** The paused window's reset time (`resets_when`, or null when unknown), or undefined when nothing is paused. */
export function pausedResetWhen(limits, refused) {
  if (refused) return refused.resets_when || null;
  if (limits?.mode === 'enforce' && limits.verdict === 'blocked') return limits.resets_when || null;
  return undefined;
}

/** Milliseconds until the paused composer should look again, or null when nothing is paused. */
export function usageRecheckDelay(limits, refused, now = Date.now()) {
  const when = pausedResetWhen(limits, refused);
  if (when === undefined) return null;
  const at = when ? new Date(when).getTime() : NaN;
  if (Number.isNaN(at)) return MAX_RECHECK_MS;
  const wait = at - now;
  return wait > 0 ? Math.min(wait + AFTER_RESET_MS, MAX_RECHECK_MS) : RETRY_MS;
}